import { useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

import SettingsCollection from '../../generic/SettingsCollection';

export default function JobTitlesListContainer() {
	const history = useHistory();
	const { localize } = useLocalize();

	return (
		<SettingsCollection
			query={graphql.useJobTitlesQuery as any}
			lazyQuery={graphql.useJobTitlesLazyQuery as any}
			field="jobTitles"
			translationKey="settings.jobTitles"
			title={(title: graphql.JobTitle) => localize(title.title).text}
			link={(title) => `/settings/job-titles/${title.id}`}
			variables={{}}
			archive={graphql.useArchiveJobTitleMutation() as any}
			restore={graphql.useRestoreJobTitleMutation() as any}
			onAdd={() => history.push('/settings/job-titles/create')}
		/>
	);
}
